const START_OF_PROJECT_TIME = '2020-10-01T00:00:00Z';
export const WINTER_START_DATE = '12-01';
export const WINTER_END_DATE = '03-10';


export const DEFAULT_PLAYBACK_SPEED = 1000 * 60 * 30

export const MAP_STYLE_ID = "bc24713045eceb6d78171160";
export const DEFAULT_MAP_OPTIONS = {
  // styles: MAP_STYLE,
  mapId: MAP_STYLE_ID,
  // renderingType: 'RASTER' as const,
  renderingType: 'VECTOR' as const,
  // disableDefaultUI: true,
  mapTypeControl: false,
  streetViewControl: true,
  fullscreenControl: false,
  clickableIcons: true,
  isFractionalZoomEnabled: true,
  tiltInteractionEnabled: true,
  cameraControl: false,
  gestureHandling: 'greedy' as const,
};

export const DEFAULT_VIEW_STATE = {
  latitude: 40.673455,
  longitude: -74.006625,
  zoom: 11,
  bearing: 0,
  pitch: 0,
}
export const NYC_BOUNDS = {
  south: 40.477399,
  west: -74.25909,
  north: 40.917577,
  east: -73.700272,
}
// const BASE_URL = import.meta.env.VITE_OGC_FEATURES_BASE || 'https://gis.floodnet.nyc/features';
// export const BASE_URL = import.meta.env.VITE_OGC_FEATURES_BASE || 'https://gis.dev.floodlabs.nyc/features';
// const BASE_URL = import.meta.env.VITE_OGC_FEATURES_BASE || 'https://features.dev.floodlabs.nyc/features';


export const SOURCES = {
  dev: {
    url: 'https://gis.dev.floodlabs.nyc/features',
    name: "Development Data",
  },
  staging: {
    url: 'https://gis.staging.floodlabs.nyc/features',
    name: "Staging Data",
  },
  live: {
    url: 'https://gis.floodnet.nyc/features',
    name: "Live Data",
  },
}

export const DEFAULT_SOURCE = 'live' as const;
export type SourceKey = keyof typeof SOURCES;

export const BASE_URL = import.meta.env.VITE_OGC_URL || SOURCES[DEFAULT_SOURCE].url;

export const OGC_FUNCTIONS = {
  // EVENT_DEPTH_DATA: 'postgisftw.event_depth_data',
  // EVENT_DEPTH_DATA: 'postgisftw.depth_data_range',
  EVENT_DEPTH_DATA: 'postgisftw.tentative_event_depth_data',
  MAX_PRECIP_DATA: 'postgisftw.max_precip_data',
}

export const OGC_COLLECTIONS = {
  SENSOR_LOCATIONS: 'ogc.sensor_locations',
  // SENSOR_LOCATIONS: 'ogc.sensor_locations_dev',
  PAST_FLOOD_EVENTS: 'ogc.past_flood_events',
}


// TODO: these should navigate / update URL params
export const LIVE_PRESET_RANGES: { label: string; fromTime: string; toTime: string }[] = [
  { label: 'Last 1 hour', fromTime: 'now-1h', toTime: 'now' },
  { label: 'Last 2 hours', fromTime: 'now-2h', toTime: 'now' },
  { label: 'Last 3 hours', fromTime: 'now-3h', toTime: 'now' },
  { label: 'Last 6 hours', fromTime: 'now-6h', toTime: 'now' },
  { label: 'Last 12 hours', fromTime: 'now-12h', toTime: 'now' },
  { label: 'Last 24 hours', fromTime: 'now-24h', toTime: 'now' },
  { label: 'Last 2 days', fromTime: 'now-2d', toTime: 'now' },
  { label: 'Last 7 days', fromTime: 'now-7d', toTime: 'now' },
  { label: 'Last 14 days', fromTime: 'now-14d', toTime: 'now' },
  { label: 'Last 30 days', fromTime: 'now-30d', toTime: 'now' },
  { label: 'Last 180 days', fromTime: 'now-180d', toTime: 'now' },
  { label: 'Last 1 year', fromTime: 'now-1y', toTime: 'now' },
  { label: 'Last 2 years', fromTime: 'now-2y', toTime: 'now' },
  { label: 'Last 5 years', fromTime: 'now-5y', toTime: 'now' },
  { label: 'Start of Project', fromTime: new Date(START_OF_PROJECT_TIME).toISOString(), toTime: 'now' },
];
export const PRESET_RANGES: { label: string; fromTime: string; toTime: string }[] = [
  // America/New_York (EDT/EST offsets applied)
  { label: "Oct 30-31, 2025", fromTime: '2025-10-30T10:00:00-04:00', toTime: '2025-10-31T08:00:00-04:00' },
  { label: "Coastal flooding - Sep 15-25 2024", fromTime: '2024-09-14T20:00:00-04:00', toTime: '2024-09-25T19:59:59-04:00' },
  { label: "Sep 29-30, 2023", fromTime: '2023-09-28T20:00:00-04:00', toTime: '2023-09-30T00:00:00-04:00' },
  { label: "Hurricane Ida", fromTime: '2021-09-01T14:00:00-04:00', toTime: '2021-09-02T06:00:00-04:00' },
  { label: "Hurricane Henri", fromTime: '2021-08-21T16:00:00-04:00', toTime: '2021-08-22T06:00:00-04:00' },
];

// OGC API serving the flood-extent product (flood_extent.* views). Unset, it
// comes from the same source as the sensor readings.
export const FLOOD_EXTENT_OGC_URL: string | undefined = import.meta.env.VITE_FLOOD_EXTENT_OGC_URL || undefined;

export const PRECIP_COG_BASE_URL = import.meta.env.VITE_PRECIP_COG_BASE_URL || 'http://localhost:3000/sample-data/cogs';

export const PRECIP_COG_INTERVAL_MS = 2 * 60 * 1000;
export const PRECIP_COG_PLAYBACK_INTERVAL_MS = 2 * 60 * 1000;

export const TIME_RANGE_NAVIGATION_ENABLED = true;
export const COMPONENT_ENABLED_WELCOME = true;
export const COMPONENT_ENABLED_APP_BAR = true;
export const COMPONENT_ENABLED_SETTINGS = true;
export const COMPONENT_ENABLED_ISLAND = true;
export const COMPONENT_ENABLED_ISLAND_CHARTS = true;


const config = {

  /* ---------------------------------- Time ---------------------------------- */

  START_OF_PROJECT_TIME,
  WINTER_START_DATE,
  WINTER_END_DATE,

  LIVE_PRESET_RANGES,
  PRESET_RANGES,

  /* ----------------------------------- Map ---------------------------------- */

  MAP_STYLE_ID,
  DEFAULT_MAP_OPTIONS,
  DEFAULT_VIEW_STATE,
  NYC_BOUNDS,

  /* ------------------------------ Data Sources ------------------------------ */

  SOURCES,
  DEFAULT_SOURCE,
  BASE_URL,
  OGC_FUNCTIONS,
  OGC_COLLECTIONS,

  // Precipitation COG (Cloud Optimized GeoTIFF) settings

  PRECIP_COG_BASE_URL,
  FLOOD_EXTENT_OGC_URL,
  PRECIP_COG_INTERVAL_MS,
  PRECIP_COG_PLAYBACK_INTERVAL_MS,

  /* ----------------------------- Feature Gates ------------------------------ */

  TIME_RANGE_NAVIGATION_ENABLED,
  COMPONENT_ENABLED_WELCOME,
  COMPONENT_ENABLED_APP_BAR,
  COMPONENT_ENABLED_SETTINGS,
  COMPONENT_ENABLED_ISLAND,
  COMPONENT_ENABLED_ISLAND_CHARTS,

}

export type AppConfig = typeof config;
export type AppConfigOverrides = Partial<AppConfig>;

export default config;
